import initialState from 'initial-state'
import models from 'interview/models'

export default {

  ...initialState,

  interview: {

    jobOpening: {
      name: '',
      slug: '',
      logo: '',
      photo: '',
      jobAds: [],
      company: {},
    },

    candidate: {
      answerSaved: false,
      error: '',
    },

    sequencedInterview: {
      networkTest: { testing: false },
      qualityTest: { testing: false },
      errorType: '',
      interviewState: {
        index: 0,
        timerCount: 0,
        takeCount: 1,
        loading: false,
        onAnswer: false,
        stopped: false,
        questionView: false,
        toNextCountdown: false,
        answerCountdown: false,
        timeLeftTilNextQuestion: 0,
      },
    },

    messages: {
      questions: [],
      videoResponses: [],
    },

  },

  ...models,

}
